import { useContext, useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';

import {
  Datepicker,
  Form,
  Number,
  Select,
  Text,
} from '../../../Components/Form';
import FileUploader from '../../../Components/Form/FileUpload';
import Textarea from '../../../Components/Form/Textarea';
import Loading from '../../../Components/Loading/Loading';
import TitleBar from '../../../Components/TitleBar/TitleBar';
import { useApi } from '../../../Hooks/Api';
import { useAuth } from '../../../Hooks/Auth';
import { useRole } from '../../../Hooks/Role';
import { useToast } from '../../../Hooks/Toast';
import Master from '../../../Layouts/Master';
import {
  getHasHasNot,
  getPhotoId,
  getStatus,
  serverErrorHandler,
} from '../../../Utils/Helpers';
import { GymContext } from '../Context/GymContext';

const validationSchema = Yup.object({
  name: Yup.string()
    .typeError('نام زورخانه الزامی است')
    .required('نام زورخانه الزامی است')
    .max(190, 'نام زورخانه نمی تواند بیشتر از 190 کاراکتر باشد'),
  province_id: Yup.number()
    .typeError('انتخاب استان الزامی است')
    .required('انتخاب استان الزامی است'),
  city_id: Yup.number()
    .typeError('انتخاب شهر الزامی است')
    .required('انتخاب شهر الزامی است'),
  manager_photo: Yup.array()
    .typeError('انتخاب عکس پرسنلی الزامی است')
    .required('انتخاب عکس پرسنلی الزامی است'),
  gym_thumbnail: Yup.array()
    .typeError('انتخاب تصاویر زورخانه الزامی است')
    .required('انتخاب تصاویر زورخانه الزامی است'),
  zip_code: Yup.string()
    .required('کد پستی الزامی است')
    .min(10, 'کد پستی باید 10 رقم باشد')
    .max(10, 'کد پستی باید 10 رقم باشد'),
  capacity: Yup.number()
    .typeError('ظرفیت تماشاچی الزامی است')
    .required('ظرفیت تماشاچی الزامی است'),
  athlete_capacity: Yup.number()
    .typeError('ظرفیت گود الزامی است')
    .required('ظرفیت گود الزامی است'),
  area: Yup.string().required(' مساحت الزامی است'),
  phone: Yup.string().required('تلفن الزامی است'),
  foundation_date: Yup.string().required('تاریخ تاسیس الزامی است'),
  address: Yup.string().required('آدرس زورخانه الزامی است'),
  type: Yup.number()
    .typeError('نوع زورخانه الزامی است')
    .required('نوع زورخانه الزامی است'),
  owner_type: Yup.number()
    .typeError('نوع مالکیت زورخانه الزامی است')
    .required('نوع مالکیت زورخانه الزامی است'),
  organization: Yup.number().typeError('').nullable(),
  first_name: Yup.string().required('نام مدیر زورخانه الزامی است'),
  last_name: Yup.string().required('نام خانوادگی مدیر زورخانه الزامی است'),
  father_name: Yup.string().required('نام پدر مدیر زورخانه الزامی است'),
  birth_date: Yup.string().required('تاریخ تولد مدیر زورخانه الزامی است'),
  manager_mobile: Yup.string()
    .required('موبایل مدیر زورخانه الزامی است')
    .min(11, 'موباید باید 11 رقم باشد و با 0 شروع شود.')
    .max(11, 'موباید باید 11 رقم باشد و با 0 شروع شود.'),
  manager_address: Yup.string().required('آدرس مدیر زورخانه الزامی است'),
  wrestling_hall: Yup.number()
    .typeError('انتخاب دارای سالن کشتی الزامی است')
    .required('انتخاب دارای سالن کشتی الزامی است'),
  status: Yup.number()
    .typeError('انتخاب وضعیت الزامی است')
    .required('انتخاب وضعیت الزامی است'),
});

const Create = () => {
  const [formSubmitLoading, setFormSubmitLoaing] = useState(false);
  const [serverErrors, setServerErrors] = useState({});
  const { check } = useAuth();
  const { can, canBoard } = useRole();
  const { get, post } = useApi();
  const { error, success } = useToast();
  const navigate = useNavigate();
  const context = useContext(GymContext);
  const [loading, setLoading] = useState(true);
  const [cityLoading, setCityLoading] = useState(false);
  const [showOrganization, setShowOrganization] = useState(false);

  useEffect(() => {
    const getData = async () => {
      await getGymTypes();
      await getTypes();
      await getOrganizations();
      await getProvinces();
    };
    getData();
  }, []);

  const getGymTypes = async () => {
    setLoading(true);
    await get(
      '/gym/gym-types',
      (res) => {
        context.gymTypes = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getTypes = async () => {
    setLoading(true);
    await get(
      '/gym/types',
      (res) => {
        context.types = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };
  const getOrganizations = async () => {
    setLoading(true);
    await get(
      '/gym/organization',
      (res) => {
        context.organizations = res.data;
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const getProvinces = async () => {
    setLoading(true);
    await get(
      '/province',
      (res) => {
        context.provinces = res.data;
        setLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات با خطا روبرو شد.');
        setLoading(false);
      },
    );
  };

  const submitForm = async (values, setSubmitingForm) => {
    if (values['gym_thumbnail'].length < 2) {
      return error('برای تصاویر زورخانه باید دو تصویر آپلود کنید.');
    }

    values['gym_thumbnail_ids'] = getPhotoId(values['gym_thumbnail']);
    values['manager_photo_id'] = getPhotoId(values['manager_photo'], false);
    if (values?.owner_type != 4) {
      values['organization'] = null;
    }
    setFormSubmitLoaing(true);
    await post(
      '/gym',
      values,
      (res) => {
        success(`زورخانه "${values?.name}" باموفقیت ثبت شد.`);
        setFormSubmitLoaing(false);
        navigate(
          check() && (can('Super Admin') || canBoard() || can('Gym Manager'))
            ? '/gym'
            : '/gym/list',
        );
      },
      (err) => {
        console.log(err);
        if (err?.status === 422) {
          serverErrorHandler(err?.data?.errors, setServerErrors, serverErrors);
          error('لطفا خطاهای فرم را رفع کنید.');
        } else {
          error(`زورخانه "${values?.name}" به علت خطا ایجاد نشد.`);
        }
        setFormSubmitLoaing(false);
      },
    );
  };
  const getCities = async (provinceId) => {
    setCityLoading(true);
    await get(
      `/city/${provinceId}`,
      (res) => {
        context.cities = res.data;
        setCityLoading(false);
      },
      (err) => {
        error('دریافت اطلاعات شهر ها با خطا روبرو شد.');
        setCityLoading(false);
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master>
      <TitleBar
        title='ثبت زورخانه'
        showBackBtn={check()}
        showCreateBtn={false}
        showFilterBtn={false}
        backPath='/gym'
      />
      <Form
        initialValues={{
          name: '',
          province_id: '',
          city_id: '',
          manager_photo: '',
          gym_thumbnail: '',
          zip_code: '',
          capacity: '',
          athlete_capacity: '',
          area: '',
          phone: '',
          foundation_date: '',
          address: '',
          type: '',
          owner_type: '',
          organization: '',
          first_name: '',
          last_name: '',
          father_name: '',
          birth_date: '',
          manager_mobile: '',
          manager_address: '',
          status: 1,
          wrestling_hall: 0,
        }}
        loading={formSubmitLoading}
        onSubmit={submitForm}
        validationSchema={validationSchema}
      >
        <div className='row'>
          <div className='col-12 col-md-8'>
            <div className='row'>
              <div className='col-12'>
                <Text
                  title='نام زورخانه'
                  name='name'
                  serverError={serverErrors.name}
                />
              </div>
              <div className='col-12'>
                <Text
                  title='کد پستی'
                  name='zip_code'
                  serverError={serverErrors.zip_code}
                />
              </div>
              <div className='col-12'>
                <Number
                  title='ظرفیت تماشاچی'
                  name='capacity'
                  serverError={serverErrors.capacity}
                />
              </div>
              <div className='col-12'>
                <Number
                  title='ظرفیت گود'
                  name='athlete_capacity'
                  serverError={serverErrors.athlete_capacity}
                />
              </div>
              <div className='col-12'>
                <Text
                  title='مساحت'
                  name='area'
                  serverError={serverErrors.area}
                />
              </div>
              <div className='col-12'>
                <Text
                  title='تلفن زورخانه'
                  name='phone'
                  serverError={serverErrors.phone}
                />
              </div>
              <div className='col-12'>
                <Datepicker
                  title='تاریخ تاسیس'
                  name='foundation_date'
                  minDate={new Date('1730/01/01')}
                  serverError={serverErrors.foundation_date}
                />
              </div>
              <div className='col-12'>
                <FileUploader
                  method='post'
                  name='gym_thumbnail'
                  title='تصاویر زورخانه (2 تصویر)'
                  maxFileSize='512KB'
                  roles={['image/jpg', 'image/jpeg', 'image/png']}
                  serverUrl='/file?location=gyms&public=0'
                  maxFiles={2}
                  serverError={serverErrors.gym_thumbnail}
                />
              </div>
              <div className='col-12'>
                <Textarea
                  name='address'
                  serverError={serverErrors.address}
                  title='آدرس زورخانه'
                />
              </div>
            </div>
          </div>
          <div className='col-12 col-md-4'>
            <div className='col-12'>
              <Select
                title='استان'
                name='province_id'
                optionLabel='name'
                optionValue='id'
                options={context.provinces}
                onChange={(value) => getCities(value)}
                serverError={serverErrors.province_id}
              />
            </div>
            {!cityLoading && context.cities.length > 0 ? (
              <div className='col-12'>
                <Select
                  title='شهر'
                  name='city_id'
                  optionLabel='name'
                  optionValue='id'
                  options={context.cities}
                  serverError={serverErrors.city_id}
                />
              </div>
            ) : (
              <div className='col-12'>
                <Select
                  title='شهر'
                  name='city_id'
                  optionLabel='name'
                  optionValue='id'
                  options={[]}
                  serverError={serverErrors.city_id}
                />
              </div>
            )}
            <div className='col-12'>
              <Select
                title='نوع زورخانه'
                name='type'
                optionLabel='title'
                optionValue='id'
                options={context.types}
                serverError={serverErrors.type}
              />
            </div>
            <div className='col-12'>
              <Select
                title='نوع مالکیت'
                name='owner_type'
                optionLabel='title'
                optionValue='id'
                onChange={(value) =>
                  setShowOrganization(value == 4 ? true : false)
                }
                options={context.gymTypes}
                serverError={serverErrors.owner_type}
              />
            </div>
            {showOrganization && (
              <div className='col-12'>
                <Select
                  title='سازمان'
                  name='organization'
                  optionLabel='title'
                  optionValue='id'
                  options={context.organizations}
                  serverError={serverErrors.organization}
                />
              </div>
            )}
            <div className='col-12'>
              <Select
                title='دارای سالن کشتی'
                name='wrestling_hall'
                optionLabel='label'
                optionValue='value'
                options={getHasHasNot()}
                serverError={serverErrors.wrestling_hall}
              />
            </div>
            <div className='col-12'>
              <div className=' my-3 border-bottom'>
                <h1 className='text-dark f-14 font-weight-bold'>
                  مشخصات مدیر زورخانه
                </h1>
              </div>
            </div>
            <div className='col-12'>
              <Text
                title='نام'
                name='first_name'
                serverError={serverErrors.first_name}
              />
            </div>
            <div className='col-12'>
              <Text
                title='نام خانوادگی'
                name='last_name'
                serverError={serverErrors.last_name}
              />
            </div>
            <div className='col-12'>
              <Text
                title='نام پدر'
                name='father_name'
                serverError={serverErrors.father_name}
              />
            </div>
            <div className='col-12'>
              <Datepicker
                title='تاریخ تولد'
                name='birth_date'
                minDate={new Date('1730/01/01')}
                serverError={serverErrors.birth_date}
              />
            </div>
            <div className='col-12'>
              <Text
                title='موبایل'
                name='manager_mobile'
                serverError={serverErrors.manager_mobile}
              />
            </div>
            <div className='col-12'>
              <Textarea
                title='آدرس'
                name='manager_address'
                serverError={serverErrors.manager_address}
              />
            </div>
            <div className='col-12'>
              <FileUploader
                method='post'
                name='manager_photo'
                title='عکس پرسنلی'
                maxFileSize='512KB'
                allowMultiple={false}
                roles={['image/jpg', 'image/jpeg', 'image/png']}
                serverUrl='/file?location=gyms&public=0'
                maxFiles={1}
                serverError={serverErrors.manager_photo}
              />
            </div>
            <div className='col-12'>
              <div className=' my-3 border-bottom'></div>
            </div>
            {check() &&
            (can('Super Admin') || canBoard() || can('Gym Manager')) ? (
              <div className='col-12'>
                <Select
                  title='وضعیت'
                  name='status'
                  optionLabel='label'
                  optionValue='value'
                  options={getStatus()}
                  serverError={serverErrors.status}
                />
              </div>
            ) : null}
          </div>
        </div>
      </Form>
    </Master>
  );
};

export default Create;
